export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-swiper/index.js